import { PaletteOptions } from '@mui/material';

const neobetPalette: PaletteOptions = {
  primary: {
    25: '#FFF8D6',
    50: '#FFF0A8',
    100: '#FFE680',
    200: '#FFDB52',
    300: '#FFD126',
    400: '#FFCE00',
    500: '#FFCE00',
    600: '#FFB800',
    700: '#C56A18',
    800: '#8F6400',
    900: '#4A3200',
    main: '#FFCE00',
  },

  secondary: {
    25: '#F6F2FF',
    50: '#ECE6FF',
    100: '#D9D1F4',
    200: '#C2B6FF',
    300: '#AA9AF9',
    400: '#9482EF',
    450: '#7841EE',
    500: '#7D69DF',
    600: '#6350BD',
    700: '#4B3C93',
    800: '#34296A',
    850: '#2B1F5C',
    900: '#201944',
    main: '#7D69DF',
  },

  error: {
    25: '#FFF1F2',
    50: '#FFE4E6',
    100: '#FECDD3',
    200: '#FDA4AF',
    300: '#FB7185',
    400: '#F43F5E',
    500: '#E11D48',
    600: '#BE123C',
    700: '#9F1239',
    800: '#881337',
    900: '#4C0519',
    main: '#E11D48',
  },

  success: {
    25: '#ECFDF5',
    50: '#D1FAE5',
    100: '#A7F3D0',
    200: '#6EE7B7',
    300: '#34D399',
    400: '#10B981',
    500: '#059669',
    600: '#047857',
    700: '#065F46',
    800: '#064E3B',
    900: '#022C22',
    main: '#10B981',
  },

  neutral: {
    25: '#FCFBFF',
    50: '#F4F1FF',
    100: '#D9D1F4',
    200: '#B9AFD8',
    300: '#978DB8',
    400: '#6C6691',
    500: '#443D67',
    600: '#2C2852',
    700: '#191939',
    800: '#121228',
    900: '#090C1D',
    A100: 'rgba(255, 255, 255, 0.08)',
  },

  info: {
    25: '#F0F9FF',
    50: '#E0F2FE',
    100: '#BAE6FD',
    200: '#7DD3FC',
    300: '#38BDF8',
    400: '#0EA5E9',
    500: '#0284C7',
    600: '#0369A1',
    700: '#075985',
    800: '#0C4A6E',
    900: '#082F49',
    main: '#0EA5E9',
  },

  background: {
    default: '#090C1D',
    paper: '#191939',
  },

  text: {
    primary: '#FFFFFF',
    secondary: '#D9D1F4',
    disabled: '#6C6691',
  },

  promoPage: {
    heading: '#FFFFFF',
    description: '#9789CD',
    duration: '#D9D1F4',
    cardBackground: '#191939',
    buttonBorder: '#090C1D',
    buttonBackground: '#2C2852',
    buttonBackgroundHover: '#463E7A',
    separator: '#463E7A',
  },

  gradient: 'linear-gradient(420deg, #FFCE00 0%, #FFCE00 15%, #FFB800 15%, #FFB800 100%)',

  divider: 'rgba(217, 209, 244, 0.12)',
} as const;

export default neobetPalette;
